import { render, staticRenderFns } from "./TimeOffCard.vue?vue&type=template&id=8c54c8ba"
import script from "./TimeOffCard.vue?vue&type=script&lang=js"
export * from "./TimeOffCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports